import { CircularProgress } from "@mui/material";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { DateTime } from 'luxon';
import { useEffect, useRef, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import addImg from '../../../../animation/Hero/addImage.svg';
import crossIcon from '../../../../animation/jobs/Cross icon.svg';
import WelcomeToCourseModal from "../../../../apps/CourseLecturePlan/Modals/WelcomeToCourseModal";
import Modal from "../../../../components/commons/Modal";
import { handleErrorMessage } from "../../../../redux/actions/classes";
import {
  clearCourses,
  deleteCourse,
  getAllCourses,
  getCourseDetails,
  updateCourseStatus,
} from "../../../../redux/actions/courses";
import { thumbnailList } from "../../../../redux/constants/commonFunctions";
import { store } from "../../../../redux/store";
import CourseContent from "../../../CourseLecturePlan/Components/CourseContent";
import ExploreCourseCard from "../../../CourseLecturePlan/Components/ExploreCourseCard";
import LinearProgressComponent from "../../../CourseLecturePlan/Components/LinearProgressComponent";
import CourseTitle from "../../Components/CourseTitle";
import CustomSelect from "../../Components/CustomSelect";
import CourseActionModal from "../../Modals/CourseActionModal";
import CreateEditCourseModal from "../../Modals/CreateEditCourseModal";
import CourseAction from "./CourseAction";
import styles from "./CourseView.module.css";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const deterministicStudentCountFromId = (id) => {
  // returns integer in [1000, 4000] deterministically from the id string
  if (!id || typeof id !== "string") return 0;
  let hash = 5381;
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) + hash) + id.charCodeAt(i);
    hash = hash & 0xffffffff;
  }
  const rangeSize = 4000 - 1000 + 1; // 3001
  const positive = Math.abs(hash);
  const offset = positive % rangeSize;
  return 1000 + offset;
};

const deterministicLearnerCountFromOwnerId = (ownerId) => {
  // returns integer in [500, 1000] deterministically from owner id string
  if (!ownerId || typeof ownerId !== "string" && typeof ownerId !== "number") return 0;
  const idStr = String(ownerId);
  let hash = 5381;
  for (let i = 0; i < idStr.length; i++) {
    hash = ((hash << 5) + hash) + idStr.charCodeAt(i);
    hash &= 0xffffffff;
  }
  const rangeSize = 1000 - 500 + 1; // 501
  const positive = Math.abs(hash);
  const offset = positive % rangeSize;
  return 500 + offset;
};

function convertToEmbedUrl(url) {
  try {
    const ytRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/;
    const match = url.match(ytRegex);
    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }
    return url;
  } catch {
    return url;
  }
}


function CourseView(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const publicCourses = useSelector((state) => state?.courses?.publicCourses) || [];
  const currentCourse = useSelector((state) => state?.courses?.currentCourse);

  const data = (currentCourse && String(currentCourse.id) === String(id))
    ? currentCourse
    : publicCourses.find(c => String(c.id) === String(id)) || null;

  const count = (typeof data?.members_count === "number" && data?.members_count >= 1000)
    ? data.members_count
    : deterministicStudentCountFromId(data?.id);

  const history = useHistory();
  const [isLoadingInfo, setLoadingInfo] = useState(true);
  const [inviteModal, setInviteModal] = useState(false)
  const [emailinvite, setEmailInvite] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [activeinviteTab, setActiveInviteTab] = useState("username");
  const [nameInvite, setNameInvite] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [suggestionsAvailable, setSuggestionsAvailable] = useState(null);

  const [activeTab, setActiveTab] = useState("content");
  const contentRef = useRef(null);
  const prereqRef = useRef(null);
  const outcomesRef = useRef(null);
  const descRef = useRef(null);

  const refMap = {
    content: contentRef,
    prereq: prereqRef,
    outcomes: outcomesRef,
    desc: descRef,
  };

  const [ownerProfile, setOwnerProfile] = useState(null);
  const [isLoadingOwnerProfile, setIsLoadingOwnerProfile] = useState(false);


  const [dropDownAction, setDropDownAction] = useState("delete");
  const [showActionModal, setShowActionModal] = useState(false);

  const [showCertModal, setShowCertModal] = useState(false);
  const certificateImageSrc = "/Image/CourseMonetisation/sampleCertificate.png";
  const infoIconSrc = "/Image/lecturePlan/quiz.svg";
  const openCertModal = (ev) => {
    ev?.preventDefault?.();
    setShowCertModal(true);
  };
  const closeCertModal = () => setShowCertModal(false);

  const [isLoading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  // const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewSrc, setPreviewSrc] = useState(null);
  const previewModalRef = useRef(null);
  const previewVideoRef = useRef(null);
  const user = store.getState().profile.user;
  const openPreview = (ev) => {
    ev?.preventDefault?.();
    const src = data?.preview_video || data?.preview_video_link || null;
    if (!src) return;
    setPreviewSrc(src);
    setShowPreview(true);
    setTimeout(() => {
      try { previewVideoRef.current?.play?.(); } catch (e) { }
    }, 50);
  };

  const closePreview = () => {
    try { previewVideoRef.current?.pause?.(); } catch (e) { }
    setShowPreview(false);
    setPreviewSrc(null);
  };

  useEffect(() => {
    if (!showPreview) return;
    const onDocClick = (e) => {
      if (previewModalRef.current && !previewModalRef.current.contains(e.target)) {
        closePreview();
      }
    };
    const onEsc = (e) => { if (e.key === "Escape") closePreview(); };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [showPreview]);

  const profileId = useSelector((state) => state?.profile?.profileId) || 0;
  const classesOwnedByTeacher = useSelector(
    (state) => state.classes.classes
  ).filter((item) => item.class_owner == profileId);

  const userDataString = localStorage.getItem("userData");
  const userData = userDataString ? JSON.parse(userDataString) : null;
  const ownerId = Number(userData?.profile_id);
  const isCourseOwner = ownerId === data?.owner?.id;

  const handleRedirectProfile = (id) => {
    history.push({
      pathname: `/profile/${id}/view`,
    });
  };

   const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
      setToastMessage("");
    }, 3000);
  };

    const handleCloseToast = () => {
    setShowToast(false);
    setToastMessage("");
  };

  const handlecloseinvite = () => {
    setInviteModal(false)
    setActiveInviteTab('username')
  }

  const handlemailinvite = (e) => {
    const value = e.target.value;
    setEmailInvite(value);

    if (value.trim() === "") {
      setFilteredData([]);
      return;
    }
    setFilteredData([]);
  };

  const handleSelect = (user) => {
    if (selectedUsers.some((s) => s.id === user.id)) return;
    setSelectedUsers([...selectedUsers, user]);
    setNameInvite("");
    setEmailInvite("");
    setFilteredData([]);
  };

  const handleRemove = (id) => {
    setSelectedUsers(selectedUsers.filter((u) => u.id !== id));
  };

  const handleRedirect = () => {
    history.push({
      pathname: "/course/create",
      state: {
        edit: true,
        courseID: data?.id,
        currentCourse: data,
        courseType: data?.public ? "Public" : "Private",
        courseTitleType: "Edit",
        classes: classesOwnedByTeacher,
      },
    });
  };

  const fetchSuggestedUsers = async () => {
    try {
      if (!id) return;


      setLoadingSuggestions(true);
      const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/suggestions/course_members/?course_id=${id}`;
      const headers = token ? { Authorization: `Token ${token}` } : {};
      const res = await axios.get(url, { headers });
      const list = res?.data?.data ?? res?.data ?? [];
      const normalized = Array.isArray(list)
        ? list.map((u) => ({
            id: u.id ?? u.profile_id ?? u.user?.id,
            name: u.name ?? u.full_name ?? `${u.first_name ?? ""} ${u.last_name ?? ""}`.trim(),
            raw: u,
          }))
        : [];

      setSuggestions(normalized.filter(Boolean));
      setSuggestionsAvailable(true); // mark success
    } catch (err) {
      console.error("Failed to fetch suggestions:", err?.response ?? err.message);
      setSuggestions([]); // clear any old server suggestions
      setSuggestionsAvailable(false); // mark failure so UI won't fallback to full local list
    } finally {
      setLoadingSuggestions(false);
    }
  };

  useEffect(() => {
    if (inviteModal && isCourseOwner && data && data.public === false) {
      fetchSuggestedUsers();
    }
  }, [inviteModal, isCourseOwner, data?.public, id]);

  const classTag = [];
  // data?.classes.map((item,index)=>{
  //     classTag.push(item.name);
  // });

  var PricingDetail = null;
  var EnrolledBox = null;
  const url = window.location.pathname.split("/").pop();

  const handleShowActionModal = (type) => {
    setDropDownAction(type);
    setShowActionModal(true);
  };

  const handleActionModal = () => {
    if (dropDownAction == "delete") {
      if (data?.members_count == 0 || !data?.active) {
        dispatch(deleteCourse(data?.id)).then(() => setShowActionModal(false));
        setShowActionModal(false);
        history.push("/courses");
      } else {
        dispatch(
          handleErrorMessage(t("courseMonetisation.cannotDeleteCourse"))
        );
        setShowActionModal(false);
      }
    } else {
      dispatch(updateCourseStatus(data?.id, !data?.active, false));
      setShowActionModal(false);
    }
  };

  const handleCancel = () => {
    setDropDownAction("");
    setShowActionModal(false);
  };

  const _get = (key) => (data && data[key] !== undefined && data[key] !== null) ? data[key] : data?.[key];

  const startDate = _get("start_date") ?? data?.start_date;
  let startsOn = "";

  if (data?.start_date && data?.isLive) {
    const [year, month, day] = startDate.split("-").map(Number);
    const dateObj = new Date(year, month - 1, day);

    if (!isNaN(dateObj.getTime())) {
      const monthName = dateObj.toLocaleString("en-US", { month: "short" });
      const dayPadded = String(dateObj.getDate()).padStart(2, "0");
      startsOn = `Starts ${monthName} ${dayPadded}`;
    }
  }

  PricingDetail = (
    <CourseAction
      data={data}
      startsOn={startsOn}
      handleRedirect={handleRedirect}
      showModal={showModal}
      handleShowActionModal={handleShowActionModal}
    />
  );

  const isEnrolledNow = _get("is_enrolled") || data?.is_enrolled;

  const addMember = async () => {
    try {
      if (selectedUsers.length === 0) {
        return;
      }

      const payload = selectedUsers.map((u) => ({
        member_users: u.id,
        course_members:id,
      }));

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/members/`,
        payload,
        {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

        showToastMessage("Members invited successfully!");
      setInviteModal(false);
    } catch (error) {
      console.error(
        "❌ Error:",
        error.response ? error.response.data : error.message
      );
      showToastMessage("Already a member");
    }
  };

  if (isEnrolledNow && !isCourseOwner) {
    EnrolledBox = (
      <Link
        to={`/course/stream/${data?.id}`}
        target={`_blank`}
        rel="noopener noreferrer"
        className={styles.link}
      >
        <div className={styles.enrolled}>
          <p>{t("courseMonetisation.resumeCourse")}</p>
        </div>
      </Link>
    );
  }

  useEffect(() => {
    // get the course details
    if (!isLoadingInfo) {
      setLoadingInfo(true);
    }
    if (!isLoading) {
      setLoading(true);
    }
    dispatch(getCourseDetails(id)).then(() => setLoadingInfo(false));
    // dispatch(getAllCourses(null, null, null, null, false)).then(()=>setLoading(false));
    // getCourseDetailById(id);
    dispatch(getAllCourses(null, true)).then(() => setLoading(false));
    return () => {
      dispatch(clearCourses());
    };
  }, [url]);

  // useEffect(() => {
  //   if (data?.showWelcomeModal) {
  //     setShowWelcomeModal(true);
  //   }
  // }, [data]);

  useEffect(() => {
    const ownerIdFromData = data?.owner?.id;
    if (!ownerIdFromData) {
      setOwnerProfile(null);
      return;
    }

    let isCancelled = false;
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchOwnerProfile = async () => {
      try {
        setIsLoadingOwnerProfile(true);

        const headers = token
          ? { Authorization: `Token ${token}` }
          : {};

        const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/${ownerIdFromData}/?target=No_Translation`;
        const res = await axios.get(url, { headers, signal });

        if (res?.status >= 200 && res?.status < 300) {
          const user = { ...(res.data?.data ?? {}) };
          if (res.data?.profile_completion_status !== undefined) {
            user.profile_completion_status = res.data.profile_completion_status;
          }

          if (typeof formatName === "function") {
            try {
              user.name = formatName(user.name);
            } catch (e) {
              console.warn("formatName failed:", e);
            }
          }

          if (!isCancelled) {
            setOwnerProfile(user);
          }
        } else {
          console.error("Profile fetch returned non-2xx:", res?.status, res?.data);
          if (!isCancelled) {
            setOwnerProfile(null);
            dispatch(handleErrorMessage("Unable to load creator profile"));
          }
        }
      } catch (error) {
        if (axios.isCancel?.(error) || error.name === "CanceledError" || error.name === "AbortError") {
          return;
        }
        console.error("Failed to load owner profile:", error);

        try {
          if (typeof errorMessageFromResponse === "function") {
            dispatch(handleErrorMessage(errorMessageFromResponse(error)));
          } else {
            dispatch(handleErrorMessage("Unable to load creator profile"));
          }
        } catch (e) {
          console.warn("Error dispatching profile fetch error:", e);
        }

        if (!isCancelled) setOwnerProfile(null);
      } finally {
        if (!isCancelled) setIsLoadingOwnerProfile(false);
      }
    };

    fetchOwnerProfile();

    return () => {
      isCancelled = true;
      // abort axios request
      try {
        controller.abort();
      } catch (e) {
        // ignore abort errors
      }
    };
  }, [data?.owner?.id, dispatch]);

  useEffect(() => {
    const sections = [
      { id: "content", ref: contentRef },
      { id: "prereq", ref: prereqRef },
      { id: "outcomes", ref: outcomesRef },
      { id: "desc", ref: descRef },
    ];

    const observerOptions = {
      root: null,
      rootMargin: "-40% 0px -40% 0px", // trigger when section near center
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const found = sections.find((s) => s.ref.current === entry.target);
          if (found) setActiveTab(found.id);
        }
      });
    }, observerOptions);

    sections.forEach((s) => {
      if (s.ref.current) observer.observe(s.ref.current);
    });

    return () => observer.disconnect();
  }, []);

  const scrollToWithOffset = (id, offset = 160) => {
    const target = refMap[id]?.current;
    if (!target) return;
    const rect = target.getBoundingClientRect();
    const top = rect.top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: "smooth" });
    setActiveTab(id);
  };

  const owner = ownerProfile ?? data?.owner ?? {};

  const MIN_WORDS = 4;
  const defaultBio = "Learning online can help students hone the technical skills they need on the job...";

  const countWords = (s) => (typeof s === "string" ? s.trim().split(/\s+/).filter(Boolean).length : 0);
  const bio =
    (countWords(data?.owner?.short_bio) >= MIN_WORDS && data?.owner?.short_bio?.trim()) ? data.owner.short_bio.trim()
      : (countWords(owner?.about) >= MIN_WORDS && owner?.about?.trim()) ? owner.about.trim()
        : defaultBio;

  const liveUrl =
    data?.meeting_link || null;

  const discountPercentage =
    data?.price && data?.discounted_price < data?.price
      ? Math.floor(((data.price - data.discounted_price) / data.price) * 100)
      : 0;

  const TIMEZONE = "Asia/Kolkata";

  const parseISODateTime = (iso) => {
    if (!iso) return null;
    try {
      const d = new Date(iso);
      if (isNaN(d.getTime())) return null;
      return d;
    } catch (e) {
      return null;
    }
  };

  const parseDateOnlyAsIST = (dateStr) => {
    if (!dateStr) return null;
    try {
      const iso = `${dateStr}T00:00:00+05:30`;
      const d = new Date(iso);
      if (isNaN(d.getTime())) return null;
      return d;
    } catch (e) {
      return null;
    }
  };

  const getMonthlyDay = (monthlyDate) => {
    if (!monthlyDate) return null;
    if (/^\s*\d{1,2}\s*$/.test(String(monthlyDate))) {
      return Number(monthlyDate);
    }
    const d = parseISODateTime(monthlyDate) || parseDateOnlyAsIST(monthlyDate);
    if (d && !isNaN(d.getTime())) return d.getDate();
    return null;
  };



  const formatDate = (dateStrOrDate) => {
    if (!dateStrOrDate) return "—";
    let d = null;
    if (typeof dateStrOrDate === "string" && dateStrOrDate.includes("T")) {
      d = parseISODateTime(dateStrOrDate);
    } else if (typeof dateStrOrDate === "string") {
      d = parseDateOnlyAsIST(dateStrOrDate);
    } else if (dateStrOrDate instanceof Date) {
      d = dateStrOrDate;
    }
    if (!d) return "—";
    return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric", timeZone: TIMEZONE });
  };

  const formatTime = (isoOrTimeStr) => {
    if (!isoOrTimeStr) return "—";
    let d = null;
    if (isoOrTimeStr.includes("T")) {
      d = parseISODateTime(isoOrTimeStr);
    } else if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(isoOrTimeStr)) {
      const [hh, mm] = isoOrTimeStr.split(":");
      const now = new Date();
      const dIso = new Date();
      dIso.setHours(Number(hh), Number(mm || 0), 0, 0);
      d = dIso;
    } else {
      return isoOrTimeStr;
    }

    if (!d || isNaN(d.getTime())) return "—";
    return d.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: TIMEZONE });
  };

  const weekdayLabel = (w) => {
    if (!w) return "";
    const map = { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun" };
    return map[String(w).toLowerCase()] ?? w;
  };

  const ordinal = (n) => {
    const num = Number(n);
    if (Number.isNaN(num)) return n;
    const s = ["th", "st", "nd", "rd"];
    const v = num % 100;
    return num + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const articleCount =
    data?.section?.reduce((acc, section) => {
      const sectionArticleCount =
        section.lectures?.filter((lec) => lec.fileType === "pdf").length || 0;
      return acc + sectionArticleCount;
    }, 0) || 0;

  const liveSessionCount =
    data?.section?.reduce((acc, section) => {
      const sectionLiveSessionCount =
        section.lectures?.filter((lec) => lec.fileType === "live").length || 0;
      return acc + sectionLiveSessionCount;
    }, 0) || 0;

  const totalSessionLengthInMinutes =
    data?.section?.reduce((totalMinutes, section) => {
      const sectionSessionDuration =
        section.lectures
          ?.filter((lec) => lec.fileType === "live")
          .reduce((sectionTotal, lec) => sectionTotal + (lec.duration || 0), 0) || 0;
      return totalMinutes + sectionSessionDuration;
    }, 0) || 0;

  const totalVideoLengthInMinutes =
    data?.section?.reduce((totalMinutes, section) => {
      const sectionVideoDuration =
        section.lectures
          ?.filter((lec) => lec.fileType === "video")
          .reduce((sectionTotal, lec) => sectionTotal + (lec.duration || 0), 0) || 0;
      return totalMinutes + sectionVideoDuration;
    }, 0) || 0;

  // Helper function to format duration from minutes to "Xh Ym"
  const formatDuration = (minutes) => {
    if (!minutes || minutes <= 0) {
      return "0 minutes of ";
    }
    if (minutes < 60) {
      return `${Math.floor(minutes)} minutes of `;
    }
    const hours = Math.floor(minutes / 60);
    return `${hours} hours of `;
  };

  const [selectedTimezone, setSelectedTimezone] = useState("ist");
  const [price, setPrice] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  let currencySymbol = "₹";

  useEffect(() => {
    if (!data?.price) return;

    const isIST = selectedTimezone.toLowerCase() === "ist";
    const rate = 85; // USD → INR conversion rate
    const symbol = isIST ? currencySymbol : "$";

    // Convert main price
    const convertedPrice = isIST ? data.price * rate : data.price;
    setPrice(`${symbol} ${convertedPrice}`);

    // Convert discounted price (if available)
    if (data.discounted_price > 0) {
      const convertedDiscounted = isIST
        ? data.discounted_price * rate
        : data.discounted_price;
      setDiscountedPrice(`${symbol} ${convertedDiscounted}`);
    } else {
      setDiscountedPrice("");
    }
  }, [selectedTimezone, data?.price, data?.discounted_price]);

  const TZ_MAP = {
    ist: "Asia/Kolkata",
    pt: "America/Los_Angeles",
    mt: "America/Denver",
    ct: "America/Chicago",
    et: "America/New_York",
    utc: "UTC",
  };

  const ABBR_MAP = {
    "Asia/Kolkata": "IST",
  };

  const parseIgnoringOffset = (timeStr, zoneCode = "utc") => {
    const zone = TZ_MAP[zoneCode?.toLowerCase()] || "UTC";
    const s = String(timeStr).trim();

    if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(s)) {
      const [hh, mm, ss] = s.split(":").map(Number);
      return DateTime.now().setZone(zone).set({
        hour: hh,
        minute: mm || 0,
        second: ss || 0,
        millisecond: 0,
      });
    }

    const cleaned = s.replace(/([+-]\d{2}:?\d{2}|Z)$/i, "");
    return DateTime.fromISO(cleaned, { zone });
  };

  const convertTimeBetweenZones = (timeStr, sourceCode = "pt", targetCode = "ist") => {
    if (!timeStr) return "—";
    const srcZone = TZ_MAP[sourceCode?.toLowerCase()] || "UTC";
    const tgtZone = TZ_MAP[targetCode?.toLowerCase()] || "UTC";

    const dt = parseIgnoringOffset(timeStr, sourceCode);
    if (!dt.isValid) return "—";

    const converted = dt.setZone(tgtZone);
    const abbr = ABBR_MAP[tgtZone] || converted.offsetNameShort;

    return `${converted.toFormat("h:mm a")} ${abbr}`;
  };

  const formatTime2 = (isoOrTimeStr, sourceTimezoneCode = "pt", selectedTimezoneCode = null) => {
    if (!isoOrTimeStr) return "—";

    if (selectedTimezoneCode) {
      return convertTimeBetweenZones(isoOrTimeStr, sourceTimezoneCode, selectedTimezoneCode);
    }

    const srcZone = TZ_MAP[sourceTimezoneCode?.toLowerCase()] || "UTC";
    const dt = parseIgnoringOffset(isoOrTimeStr, sourceTimezoneCode);
    if (!dt.isValid) return "—";
    const abbr = ABBR_MAP[srcZone] || dt.offsetNameShort;

    return `${dt.toFormat("h:mm a")} ${abbr}`;
  };


  return (
    <div className={styles.CourseView}>
       {showToast && (
                  <div className={styles.emailinviteToast}><span>{toastMessage}</span>
<span className={styles.closeIcon} onClick={handleCloseToast}>&times;</span>
</div>

  )}
      {showModal && (
        <CreateEditCourseModal
          key={data?.id}
          courseId={data?.id}
          currentMediaFiles={data?.files}
          currentUrls={data?.urls}
          courseTitleType={t("common.edit")}
          coursePriceValue={data?.price}
          isCourseFreeEdit={data?.price === 0 ? "FREE" : "PAID"}
          courseName={data?.name}
          courseSubtitle={data?.subtitle}
          courseDescription={data?.description}
          classTags={data?.classes}
          courseType={data?.public ? t("common.Public") : t("common.Private")}
          closeModal={handleRedirect}
          show={showModal}
          courseView={true}
          isActive={data?.active}
        />
      )}
      {showActionModal && (
        <Modal
          card={
            <CourseActionModal
              type={dropDownAction}
              onCancel={handleCancel}
              onConfirm={handleActionModal}
            />
          }
        ></Modal>
      )}
      {/* {showWelcomeModal && (
        <Modal
          card={
            <WelcomeToCourseModal
              welcome={true}
              courseID={data?.id}
              courseName={data?.name}
              closeModal={() => setShowWelcomeModal(false)}
            />
          }
          onOutsideClick={() => setShowWelcomeModal(false)}
        />
      )} */}
      {showCertModal && (
        <Modal
          card={
            <div className={styles.certModalCard} role="dialog" aria-modal="true" aria-label="Sample certificate preview">
              <div className={styles.certModalHeader}>
                <h2 className={styles.certModalTitle}>{t("course.sampleCertificate")}</h2>
                <button
                  type="button"
                  onClick={closeCertModal}
                  className={styles.certModalClose}
                  aria-label="Close"
                >
                  <img src="/Image/lecturePlan/plus2.svg" className={styles.certModalCloseIcon} />
                </button>
              </div>

              <div className={styles.certModalBody}>
                <img
                  src={certificateImageSrc}
                  alt="Sample certificate"
                  className={styles.certImage}
                  width="655"
                  height="468"
                />
              </div>
            </div>
          }
        />
      )}
      {showPreview && (
        <div
          role="dialog"
          aria-modal="true"
          className={styles.previewOverlay}
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.6)",
            zIndex: 2000,
            padding: 20,
          }}
        >
          <div
            ref={previewModalRef}
            className={styles.previewModalCard}
            style={{
              width: "min(1000px, 95%)",
              maxWidth: 1000,
              borderRadius: 8,
              background: "#000",
              boxShadow: "0 8px 30px rgba(0,0,0,0.5)",
              overflow: "hidden",
            }}
          >
            <div style={{ position: "relative", paddingTop: "56.25%" /* 16:9 aspect ratio */ }}>
              {previewSrc?.includes("youtube.com") || previewSrc?.includes("youtu.be") ? (
                <iframe
                  src={convertToEmbedUrl(previewSrc)}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: 0,
                  }}
                />
              ) : (
                <video
                  ref={previewVideoRef}
                  src={previewSrc}
                  controls
                  playsInline
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "#000",
                  }}
                />
              )}
            </div>
            <button
              onClick={closePreview}
              aria-label="Close preview"
              style={{
                position: "absolute",
                top: 12,
                right: 12,
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: 20,
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}
      {isLoadingInfo ? (
        <div className={styles.loader}>
          <CircularProgress sx={{ color: "#F33070" }} size={50} />
        </div>
      ) : (
        <div className={styles.CourseDetails}>
          <div className={styles.CourseDetailsLeft}>
            <div className={styles.CourseDetailsLeft1}>

              <div className={styles.staticBanner}>
                <img
                  src="/Image/CourseMonetisation/course-static-image.png"
                  alt="CourseBanner"
                />
              </div>

              <div className={styles.badges}>
                {data?.isLive && (
                  (profileId === data?.owner?.id || data?.is_enrolled) && liveUrl ? (
                    <a
                      className={styles.liveBadge}
                      href={liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      role="link"
                      aria-label="Open live class"
                      title="Open live class"
                    >
                      {t("course.liveLearning")}
                    </a>
                  ) : (
                    <a
                      className={styles.liveBadge}
                      href={liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      role="link"
                      aria-label="Live course (not accessible)"
                      aria-disabled="true"
                      title={data?.is_enrolled ? "Live course" : "Enroll to access live class"}
                    >
                      {t("course.liveLearning")}
                    </a>
                  )
                )}

                {/* Course Level Badge */}
                {data?.course_level && (
                  <span className={`${styles.levelBadge} ${styles[data.course_level.toLowerCase()]}`}>
                    {t(`course.${data.course_level}`)}
                  </span>
                )}
              </div>

              <div className={styles.CourseDetailsLeft1Content}>
                <div className={styles.titleRow}>
                  <div key={data?.id || null}>
                    <p
                      className={styles.icon_text_large}
                    >
                      {data?.name}
                    </p>
                  </div>
                </div>

                <h4 className={styles.caption}>{data?.subtitle}</h4>

                <div className={styles.student_count}>
                  <img style={{ width: 18, height: 18 }}  src="/Image/CourseMonetisation/Learners.svg" alt="" />
                  <span>{(count > 1) ? (count + ` ${t("courseMonetisation.learners")}`) : count + ` ${t("courseMonetisation.learners")}` }</span>
                </div>

                {data?.tags?.length > 0 && (
                  <div className={styles.tags_row}>
                    <Stack
                      direction="row"
                      spacing={0.4}
                      sx={{ flexWrap: 'wrap', width: '100%' }}    // <-- ensure wrap on the Stack
                    >
                      {data.tags.map((tag, i) => (
                        <Chip
                          key={i}
                          label={tag}
                          variant="outlined"
                          className={styles.tag_chip}
                          size="small"
                        />
                      ))}
                    </Stack>
                  </div>
                )}

                {/* LIVE SCHEDULE */}
                {data?.isLive && (
                  <section
                    className={styles.liveSchedule}
                    role="region"
                    aria-labelledby="live-schedule-heading"
                  >
                    <h3 id="live-schedule-heading" className={styles.liveScheduleTitle}>
                      🔴 Live Sessions
                    </h3>

                    <div className={styles.liveScheduleCard}>
                      <div className={styles.liveScheduleContent}>
                        {(() => {
                          const repeat = (_get("repeat") ?? "none").toString();
                          const startDateRaw = _get("start_date") ?? null;
                          const repeatUntilRaw = _get("repeat_until") ?? null;
                          const startTimeRaw = _get("start_time");
                          const weekdays = _get("repeat_weekdays") ?? [];
                          const monthlyDate = _get("repeat_monthly_date");
                          const timezone = _get("timezone") ?? "";


                          if (!repeat || repeat === "none") {
                            return (
                              <>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/time-icon.svg" className={styles.liveIconsTime} aria-hidden="true" />
                                  <div className={styles.liveLabel}>Time :</div>
                                  <div className={styles.timeBadge}>
                                    {formatTime2(startTimeRaw, (timezone || "pt"), selectedTimezone)}
                                  </div>
                                </div>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/Until-icon.svg" className={styles.liveIconsUntil} aria-hidden="true" />
                                  <div className={styles.liveLabel}>When :</div>
                                  <div className={styles.dateBadge}>{formatDate(repeatUntilRaw)}</div>
                                </div>
                              </>
                            );
                          }

                          if (repeat === "daily") {
                            return (
                              <>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/Repeat-icon.svg" className={styles.liveIcons} aria-hidden="true" />
                                  <div className={styles.liveLabel}>Repeats :</div>
                                  <span className={styles.dailyBadge}>Daily</span>
                                </div>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/time-icon.svg" className={styles.liveIconsTime} aria-hidden="true" />
                                  <div className={styles.liveLabel}>Time :</div>
                                  <div className={styles.timeBadge}>
                                    {formatTime2(startTimeRaw, (timezone || "pt"), selectedTimezone)}
                                  </div>
                                </div>
                                {startDateRaw &&
                                  <div className={styles.liveRow}>
                                    <img src="/Image/CourseMonetisation/LiveSchedule/start.svg" className={styles.liveIconsTime} aria-hidden="true" />
                                    <div className={styles.liveLabel}>Start :</div>
                                    <div className={styles.dateBadge}>{formatDate(startDateRaw)}</div>
                                  </div>
                                }
                                {repeatUntilRaw &&
                                  <div className={styles.liveRow}>
                                    <img src="/Image/CourseMonetisation/LiveSchedule/Until-icon.svg" className={styles.liveIconsUntil} aria-hidden="true" />
                                    <div className={styles.liveLabel}>Until :</div>
                                    <div className={styles.dateBadge}>{formatDate(repeatUntilRaw)}</div>
                                  </div>
                                }
                              </>
                            );
                          }

                          if (repeat === "weekly") {
                            return (
                              <>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/Repeat-icon.svg" className={styles.liveIcons} aria-hidden="true" />
                                  <div className={styles.liveLabel}>Repeats :</div>
                                  <div className={styles.liveValue}>
                                    <div className={styles.weekdays}>
                                      {Array.isArray(weekdays) && weekdays.length > 0
                                        ? weekdays.map((w) => {
                                          const lower = String(w).toLowerCase();
                                          return (
                                            <span
                                              key={w}
                                              className={`${styles.weekdayBadge} ${styles[`${lower}Badge`]}`}
                                            >
                                              {weekdayLabel(w)}
                                            </span>
                                          );
                                        })
                                        : <span className={styles.weekdayBadge}>—</span>}
                                    </div>
                                  </div>
                                </div>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/time-icon.svg" className={styles.liveIconsTime} aria-hidden="true" />
                                  <div className={styles.liveLabel}>Time :</div>
                                  <div className={styles.timeBadge}>
                                    {formatTime2(startTimeRaw, (timezone || "pt"), selectedTimezone)}
                                  </div>
                                </div>
                                {startDateRaw &&
                                  <div className={styles.liveRow}>
                                    <img src="/Image/CourseMonetisation/LiveSchedule/start.svg" className={styles.liveIconsTime} aria-hidden="true" />
                                    <div className={styles.liveLabel}>Start :</div>
                                    <div className={styles.dateBadge}>{formatDate(startDateRaw)}</div>
                                  </div>
                                }
                                {repeatUntilRaw &&
                                  <div className={styles.liveRow}>
                                    <img src="/Image/CourseMonetisation/LiveSchedule/Until-icon.svg" className={styles.liveIconsUntil} aria-hidden="true" />
                                    <div className={styles.liveLabel}>Until :</div>
                                    <div className={styles.dateBadge}>{formatDate(repeatUntilRaw)}</div>
                                  </div>
                                }
                              </>
                            );
                          }

                          if (repeat === "monthly") {
                            const monthlyDay = getMonthlyDay(monthlyDate);
                            return (
                              <>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/Repeat-icon.svg" className={styles.liveIcons} aria-hidden="true" />
                                  <div className={styles.liveLabel}>Repeats :</div>
                                  <span className={styles.monthlyBadge}>Monthly</span>
                                </div>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/Until-icon.svg" className={styles.liveIconsUntil} aria-hidden="true" />
                                  <div className={styles.liveLabel}>On :</div>
                                  <div className={styles.dateBadge}>{ordinal(monthlyDay)} of Every Month</div>
                                </div>
                                <div className={styles.liveRow}>
                                  <img src="/Image/CourseMonetisation/LiveSchedule/time-icon.svg" className={styles.liveIconsTime} aria-hidden="true" />
                                  <div className={styles.liveLabel}>Time :</div>
                                  <div className={styles.timeBadge}>
                                    {formatTime2(startTimeRaw, (timezone || "pt"), selectedTimezone)}
                                  </div>
                                </div>
                                {startDateRaw &&
                                  <div className={styles.liveRow}>
                                    <img src="/Image/CourseMonetisation/LiveSchedule/start.svg" className={styles.liveIconsTime} aria-hidden="true" />
                                    <div className={styles.liveLabel}>Start :</div>
                                    <div className={styles.dateBadge}>{formatDate(startDateRaw)}</div>
                                  </div>
                                }
                                {repeatUntilRaw &&
                                  <div className={styles.liveRow}>
                                    <img src="/Image/CourseMonetisation/LiveSchedule/Until-icon.svg" className={styles.liveIconsUntil} aria-hidden="true" />
                                    <div className={styles.liveLabel}>Until :</div>
                                    <div className={styles.dateBadge}>{formatDate(repeatUntilRaw)}</div>
                                  </div>
                                }
                              </>
                            );
                          }

                          // fallback
                          return (
                            <>
                              <div className={styles.liveRow}>
                                <div className={styles.liveLabel}>Schedule</div>
                                <div className={styles.liveValue}>
                                  {repeat} — {formatDate(repeatUntilRaw)} — {formatTime(startTimeRaw)} {timezone.toUpperCase()}
                                </div>
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </section>
                )}
              </div>
            </div>

            <div className={styles.CourseDetailsLeft2}>
              <div className={styles.TabNav}>
                <button
                  className={`${styles.TabButton} ${activeTab === "content" ? styles.active : ""}`}
                  onClick={() => scrollToWithOffset("content")}
                >{t("course.courseContent")}</button>

                {data?.prerequisites?.length > 0 && (
                  <>
                    <div className={styles.TabDivider}></div>
                    <button
                      className={`${styles.TabButton} ${activeTab === "prereq" ? styles.active : ""}`}
                      onClick={() => scrollToWithOffset("prereq")}
                    >{t("course.prerequisites")}</button>
                  </>
                )}

                {data?.learning_outcomes?.length > 0 && (
                  <>
                    <div className={styles.TabDivider}></div>
                    <button
                      className={`${styles.TabButton} ${activeTab === "outcomes" ? styles.active : ""}`}
                      onClick={() => scrollToWithOffset("outcomes")}
                    >{t("course.learningOutcomes")}</button>
                  </>
                )}

                {data?.description && (
                  <>
                    <div className={styles.TabDivider}></div>
                    <button
                      className={`${styles.TabButton} ${activeTab === "desc" ? styles.active : ""}`}
                      onClick={() => scrollToWithOffset("desc")}
                    >{t("course.description")}</button>
                  </>
                )}
              </div>

              <div className={styles.CourseDetailsLeft2Content}>
                <div ref={contentRef}>
                  <CourseContent
                    content={data?.section}
                    isEnrolled={data?.is_enrolled}
                    progress={data?.progress_bar}
                    totalLecture={data?.total_lecs}
                    courseLength={data?.course_mins}
                  />
                </div>

                {data?.prerequisites?.length > 0 && (
                  <div className={styles.content} ref={prereqRef}>
                    <div className={styles.contentHeader}>{t("course.prerequisites")}</div>
                    <div className={styles.contentDiv}>
                      <ul>
                        {data?.prerequisites?.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {data?.learning_outcomes?.length > 0 && (
                  <div className={styles.content} ref={outcomesRef}>
                    <div className={styles.contentHeader}>{t("course.learningOutcomes")}</div>
                    <div className={styles.outcomesGrid}>
                      {data?.learning_outcomes?.map((item, i) => (
                        <div key={i} className={styles.outcomeItem}>
                          <span className={styles.check}><img src="/Image/CourseMonetisation/check.svg" alt="" /></span>
                          <span>{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {data?.description && (
                  <div className={styles.content} ref={descRef}>
                    <div className={styles.contentHeader}>{t("course.description")}</div>
                    <div className={styles.contentDiv}>
                      <p>{data?.description}</p>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>

          <div className={styles.CourseDetailsRight}>
            <div className={styles.CourseDetailsRightAction}>
              {(data?.preview_video || data?.preview_video_link) &&
                <button
                  type="button"
                  onClick={openPreview}
                  className={styles.previewBadge}
                  aria-label="Open preview video"
                >
                  <span>{t("course.preview")}</span>
                  <div className={styles.previewBadgeDiv} />
                  <img src="/Image/CourseMonetisation/preview-video-icon.svg" alt="" />
                </button>
              }
              <div className={styles.thumbnail}>
                {data?.thumbnail ? (
                  <img src={data?.thumbnail} alt="CourseBanner" className={styles.thumbImg} />
                ) : (
                  <img
                    src="/Image/CourseMonitization/CourseViewBanner.png"
                    alt="CourseBanner"
                    className={styles.thumbImg}
                  />
                )}
              </div>
              <div className={styles.priceCard}>
                {(!data?.is_enrolled || profileId === data?.owner?.id) && (
                  <div className={styles.priceRow}>
                    <div className={styles.priceLeft}>
                      <div className={styles.priceLabel}>{t("course.fullAccess")}</div>
                      {!data?.free ? (
                        <>
                          {data?.discounted_price ? (
                            <div className={styles.priceValue}>
                              <div className={styles.amountDiv}>
                                <span className={styles.amount}>{discountedPrice}</span>
                                <span className={styles.amountOld}>{price}</span>
                              </div>
                              <div className={styles.discountBadge}>-{discountPercentage}%</div>
                            </div>
                          ): (
                            <div className={styles.priceValue}>
                              <span className={styles.amount}>{price}</span>
                            </div>
                          )}
                        </>
                      ):(
                        <div className={styles.priceValue}>
                          <span className={styles.amount}>{t("course.free")}</span>
                        </div>
                      )}
                    </div>

                    <div className={styles.selectWrap}>
                      <CustomSelect
                        name="selectedTimezone"
                        options={[
                          { value: "ist", label: <><img src="/Image/CourseMonetisation/flag-india-icon.png" alt="IST" className={styles.flag} /> IST</> },
                          { value: "pt", label: <><img src="/Image/CourseMonetisation/flag-usa-icon.png" alt="PST" className={styles.flag} /> PT</> },
                          { value: "mt", label: <><img src="/Image/CourseMonetisation/flag-usa-icon.png" alt="MDT" className={styles.flag} /> MT</> },
                          { value: "ct", label: <><img src="/Image/CourseMonetisation/flag-usa-icon.png" alt="CDT" className={styles.flag} /> CT</> },
                          { value: "et", label: <><img src="/Image/CourseMonetisation/flag-usa-icon.png" alt="EDT" className={styles.flag} /> ET</> },
                        ].map(o => ({ ...o, label: typeof o.label === "string" ? o.label : <span className={styles.selectLabel}>{o.label}</span> }))}
                        value={selectedTimezone}
                        onChange={(e) => setSelectedTimezone(e.target.value)}
                        placeholder="IST"
                      />
                    </div>
                  </div>
                )}

                <div className={styles.includes}>
                  <div className={styles.includesTitle}>{t("course.includes")}</div>
                  <ul className={styles.includesList}>
                    <li>
                      {data?.isLive ? (
                        <>
                          <img src="/Image/CourseMonetisation/LiveSchedule/start.svg" alt="" className={styles.includeIcon} />
                          <span>{formatDuration(totalSessionLengthInMinutes) + "live learning"}</span>
                        </>
                      ) : (
                        <>
                          <img src="/Image/CourseMonetisation/video-line.svg" alt="" className={styles.includeIcon} />
                          <span>{formatDuration(totalVideoLengthInMinutes) + "video"}</span>
                        </>
                      )}

                    </li>
                    <li>
                      {data?.isLive ? (
                        <>
                          <img src="/Image/CourseMonetisation/live-line.svg" alt="" className={styles.includeIcon} />
                          <span>{liveSessionCount} {liveSessionCount === 1 ? "live session" : "live sessions"}</span>
                        </>
                      ) : (
                        <>
                          <img src="/Image/CourseMonetisation/article.svg" alt="" className={styles.includeIcon} />
                          <span>{articleCount} {articleCount === 1 ? "article" : "articles"}</span>
                        </>
                      )}
                    </li>
                    <li>
                      <img src="/Image/CourseMonetisation/mobile.svg" alt="" className={styles.includeIcon} />
                      <span>{t("course.mobileWebAccess")}</span>
                    </li>
                    <li className={styles.certificateRow}>
                      <button
                        type="button"
                        onClick={openCertModal}
                        className={styles.certificateButton}
                        aria-label="Preview sample certificate"
                      >
                        <img src="/Image/CourseMonetisation/certification.svg" alt="" className={styles.includeIcon} />
                        {t("course.certificate")}
                        <img
                          src={infoIconSrc}
                          alt="Info"
                          className={styles.certInfoInline}
                          onClick={openCertModal}
                          role="button"
                          aria-label="Click to preview a sample certificate"
                          title="Click to preview a sample certificate"
                        />
                      </button>
                    </li>
                  </ul>
                </div>
                {data?.is_enrolled && data?.owner?.id !== profileId && (
                  <div className={styles.progress_container}>
                    <span>{t("courseMonetisation.yourProgress")}</span>
                    <LinearProgressComponent progress={data?.progress_bar ?? 0} />
                  </div>
                )}

                {EnrolledBox}
                {PricingDetail}
              </div>
            </div>

            {user?.user_type === "LOCAL BUSINESS" && isCourseOwner && !data?.public && (
              <>
                <button
                  className={styles.inviteButton}
                  onClick={() => setInviteModal(true)}
                >
                  Invite
                </button>

                {/* Invite Modal */}
                {inviteModal && (
                  <Modal
                    card={
                      <div className={styles.inviteCard}>
                        <h2 className={styles.inviteTitle}>
                          <img src={addImg} alt="Add" className={styles.addIcon} />
                          {t("course.invitePeople")}
                          <button
                            onClick={handlecloseinvite || (() => setInviteModal(false))}
                            className={styles.buttoninvite}
                          >
                            <img src={crossIcon} width={15} height={15} alt="Close" />
                          </button>
                        </h2>


                        {/* <div className={styles.tabs}>
                          <span
                            className={activeinviteTab === 'code' ? styles.activeinviteTab : styles.tab}
                            onClick={() => setActiveInviteTab('code')}
                          >
                            Share Class Code
                          </span>
                          <span
                            className={activeinviteTab === 'username' ? styles.activeinviteTab : styles.tab}
                            onClick={() => setActiveInviteTab('username')}
                          >
                            Invite by Username
                          </span>
                        </div> */}
                        {/* {activeinviteTab === 'code' ? (


                          <>
                            <div className={styles.classCodeBox}>
                              <h3>{"ABCD-1234"}</h3>
                              <svg
                                className={styles.copyIcon}
                                onClick={() => navigator.clipboard.writeText("ABCD-1234")}
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                                style={{ cursor: 'pointer', marginLeft: '40px', width: '24px', height: '24px' }}
                              >

                                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                              </svg>
                            </div>

                            <p className={styles.text}>Copy and share this class code to students to join the class.</p>
                            <button
                              className={styles.doneButton}
                              onClick={() => setInviteModal(false)}
                            >
                              Done
                            </button>
                          </>
                        ) : ( */}
                          <div className={styles.inviteByUsernameContent}>
                            <p className={styles.textCenter}>
                              {t("course.invitePeople")}
                            </p>

                            <div className={styles.selectedList}>
                              {selectedUsers.map((user) => (
                                <div key={user.id} className={styles.selectedChip}>
                                  {user.name} ({user.id})
                                  <span
                                    className={styles.removeIcon}
                                    onClick={() => handleRemove(user.id)}
                                  >
                                    <img src={crossIcon} width={10} height={10} />
                                 </span>
                                </div>
                              ))}
                            </div>

                            <div style={{ position: "relative" }}>
                              <Autocomplete
                                options={
                                  suggestionsAvailable === true
                                    ? suggestions.filter(
                                        (u) =>
                                          !selectedUsers.some((sel) => sel.id === u.id)
                                      )
                                    : []
                                }
                                getOptionLabel={(option) => option.name || ""}
                                value={null}
                                onChange={(_, value) => {
                                  if (value) handleSelect(value);
                                }}
                                onInputChange={(_, value) => {
                                  setNameInvite(value);
                                  if (!value.trim()) {
                                    setFilteredData([]);
                                  }
                                }}
                                loading={loadingSuggestions}
                                noOptionsText={
                                  suggestionsAvailable === false
                                    ? t("course.couldNotLoadSuggestions")
                                    : t("course.noUsersFound")
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Type a name"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                  />
                               )}
                                sx={{ width: "100%" }}
                              />

                              {suggestionsAvailable === false && (
                                <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
                                  <span style={{ color: "#d32f2f", fontSize: 12 }}>{t("course.couldNotLoadSuggestions")}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setSuggestionsAvailable(null);
                                      fetchSuggestedUsers();
                                    }}
                                    style={{
                                      padding: "2px 4px",
                                      borderRadius: 8,
                                      border: "1px solid #f33070",
                                      background: "#f33070",
                                      color: "#fff",
                                      cursor: "pointer",
                                      fontSize: 12
                                    }}
                                  >
                                    {t("course.retry")}
                                  </button>
                                </div>
                              )}
                            </div>

                            {loadingSuggestions && (
                              <div style={{ padding: 8 }}>
                                <CircularProgress size={20} />
                              </div>
                            )}

                            {filteredData.length > 0 && (
                              <ul className={styles.listContainer}>
                                {filteredData.map((item) => (
                                  <li
                                    key={item.id}
                                    className={styles.listItem}
                                    onClick={() => {
                                      handleSelect(item);
                                    }}
                                  >
                                    {item.name}
                                  </li>
                                ))}
                              </ul>
                            )}

                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 16 }}>
                              <button
                                className={`${styles.doneButton} ${selectedUsers.length > 0 ? styles.doneButtonActive || '' : ''}`}
                                onClick={addMember}
                                disabled={selectedUsers.length === 0}
                                // Inline visual state so it works without adding new CSS immediately.
                                style={
                                  selectedUsers.length > 0
                                    ? { background: "#F33070", color: "#fff", border: "none", cursor: "pointer" }
                                    : { background: "#a6a6a6", color: "#fff", border: "none", cursor: "not-allowed", pointerEvents: "auto" }
                                }
                                aria-disabled={selectedUsers.length === 0}
                              >
                                {t("course.invite")}
                              </button>

                              <button
                                className={styles.doneButton}
                                onClick={() => { setInviteModal(false); setActiveInviteTab('code'); }}
                              >
                                {t("course.cancel")}
                              </button>
                            </div>
                          </div>
                        {/* )} */}
                      </div>
                    }
                  />
                )}
              </>
            )}

            <div className={styles.CourseDetailsRightCreator}>
              <div className={styles.creatorBadges}>
                <a href={`/profile/${data?.owner?.id}/view`} target="_blank" rel="noopener noreferrer">
                  <img
                    src="/Image/CourseMonetisation/nxnearby-icon.png"
                    alt="nxNearby"
                    className={styles.creatorIcon}
                  />
                </a>
                {data?.owner?.social_links?.linkedin ? (
                  <a
                    href={owner.social_links.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/Image/CourseMonetisation/linkedin-icon.png"
                      alt="LinkedIn"
                      className={styles.creatorIcon}
                    />
                  </a>
                ) : null}
              </div>
              <div className={styles.creatorHeader}>
                <p className={styles.creatorSubtitle}>{t("course.knowInstructor")}</p>
              </div>

              <div className={styles.creatorInfo}>
                {owner?.profile_pic || owner?.avatarImg ? (
                  <img
                    src={owner.profile_pic ?? owner.avatarImg}
                    alt="Creator Avatar"
                    className={styles.creatorAvatar}
                  />
                ) : (
                  <img
                    src="/Image/profile.png"
                    alt="Creator Avatar"
                    className={styles.creatorAvatar}
                  />
                )}
                <div>
                  <h2 className={styles.creatorName}>{data?.owner?.name}</h2>
                  {owner?.designation ? (
                    <p className={styles.creatorRole}>{owner.designation}</p>
                  ) : (
                    <p className={styles.creatorRole}>{t("course.instructor")}</p>
                  )}
                </div>
              </div>

              <p className={styles.creatorBio} title={bio} data-full={bio}>
                {bio}
              </p>
              <div className={styles.creatorStats}>
                <p className={styles.statItem}>
                  <img className={styles.statIcon} src="/Image/CourseMonetisation/Learners.svg" alt="" />
                  <span className={styles.statText}>
                    {deterministicLearnerCountFromOwnerId(data?.owner?.id)} learners
                  </span>
                </p>

                <p className={styles.statItem}>
                  <img className={styles.statIcon} src="/Image/CourseMonetisation/total-courses(creator).svg" alt="" />
                  <span className={styles.statText}>
                    {data?.owner?.totalCourses ?? "0"} courses
                  </span>
                </p>
              </div>
            </div>



            <div className={styles.exploration}>
              <CourseTitle title="Explore" />

              <div className={styles.exploreCards}>
                {publicCourses?.length > 0 &&
                  publicCourses
                    ?.filter((publicCourse) => {
                      const isCourseOwner = publicCourse?.owner?.id === ownerId;

                      if (isCourseOwner) {
                        return true;
                      } else {
                        return publicCourse?.is_draft === false;
                      }
                    })
                    .map((publicCourse, ind) => (
                      <ExploreCourseCard
                        key={publicCourse?.id}
                        ind={ind}
                        id={publicCourse?.id}
                        thumbnail={publicCourse?.thumbnail ?? thumbnailList[ind % 13]}
                        public={publicCourse?.public}
                        name={publicCourse?.name}
                        price={publicCourse?.price}
                        ownerName={publicCourse?.owner?.name}
                        memberCount={deterministicStudentCountFromId(publicCourse?.id)}
                        classes={publicCourse?.classes}
                        courseLength={publicCourse?.course_mins}
                      />
                    ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state, props) => {
  return {
    data: state,
  };
};
//   const mapDispatchToProps = (dispatch) => {
//     return {
//       const getCourseDetailById: (id) => dispatch(getCourseDetails(id)),

//     };
//   };
export default withTranslation()(connect(mapStateToProps)(CourseView));
